import { format, getTime, formatDistanceToNow ,parse} from 'date-fns';
import Moment from 'moment';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
    const fm = newFormat || 'dd MMM yyyy';

    return date ? format(new Date(date), fm) : '';
}

export function newFDate(date, newFormat) {
    const fm = newFormat || 'dd-MMM-yyyy';

    return date ? format(new Date(date), fm) : '';

}

export function fDateTime(date, newFormat) {
    const fm = newFormat || 'dd MMM yyyy p';

    return date ? format(new Date(date), fm) : '';
}

export function fMonth(date, newFormat) {
    const fm = newFormat || 'MMM-yyyy';

    return date ? format(new Date(date), fm) : '';
}

export function fDateTimeNew(date, newFormat) {
    const fm = newFormat || 'dd MMM yyyy hh:mm:ss a';

    return date ? format(new Date(date), fm) : '';
}

export function fDateTimeNewHours(date, newFormat) {
    const fm = newFormat || 'dd MMM yyyy HH:mm:ss';

    return date ? format(new Date(date), fm) : '';
}


export function fTimestamp(date) {
    return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
    return date
        ? formatDistanceToNow(new Date(date), {
            addSuffix: true,
        })
        : '';
}

const iSTMinutes = 330;

export function getDateStringInUserTimeZone(date) {

    return Moment(date).add(iSTMinutes, 'minutes').format('DD-MMM-yyyy');
}

export function lastupdatedateTime(date) {

    return Moment(date).add(iSTMinutes, 'minutes').format('DD-MMM-yyyy hh:mm:ss a');
}

export function flastUpdatedDateTimeNew(date, newFormat) {
    const fm = newFormat || 'dd-MMM-yyyy hh:mm:ss a';

    return date ? format(new Date(date), fm) : '';
}

export function fONDate(date, newFormat) {
    const fm = newFormat || 'yyyy-MM-dd';

    const newDate = new Date(date?.getFullYear(), date?.getMonth(), 1);
    return date ? format(new Date(newDate), fm) : '';
}

export function fCloseMonthDate(date) {

    return Moment(date, 'MMM-YYYY').format('YYYY-MM-DD');
}

export function fDateForDashboard(date, newFormat) {
    const fm = newFormat || 'yyyy-MM-dd';

    return date ? format(new Date(date), fm) : '';
}

export function fAgreementDate(date, newFormat) {
    const fm = newFormat || 'dd/MM/yyyy';

    return date ? format(new Date(date), fm) : '';
}

export function fDateMonth(date, newFormat) {
    const fm = newFormat || 'dd-MM';

    return date ? format(new Date(date), fm) : '';
}

export function fDateMonthYear(date, newFormat) {
    const fm = newFormat || 'dd-MM-yyyy';

    return date ? format(new Date(date), fm) : '';
}

export function fDateforyyyyMMMdd(date, newFormat) {
    const fm = newFormat || 'yyyyMMMdd';

    return date ? format(new Date(date), fm) : '';
}

export function formatDate(dateString) {
    const formattedDate = Moment(dateString, "DD-MM-YYYY HH:mm:ss").format("MMM-yyyy");
    return formattedDate;
}

export function fDataUploadDateTime(date) {

    return Moment(date).add(iSTMinutes, 'minutes').format('DD-MMM-yyyy hh:mm:ss');
}

export function fDateForSNS(date, newFormat) {
    const fm = newFormat || 'yyyy-MM-dd hh:mm:ss';

    return date ? format(new Date(date), fm) : '';
}

export function fDateTime24Hr(date, newFormat) {
    const fm = newFormat || 'yyyy-MM-dd HH:mm:ss';

    return date ? format(new Date(date), fm) : '';
}

export function fTime(timeString) {
    const time = new Date(`1970-01-01T${timeString}`).toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
    });
    return time;
};

export function fDateTimeForLog(date, newFormat) {
    const fm = newFormat || 'yyyy-MM-dd HH:mm:ss';
    const newDate = new Date(date);
    newDate.setHours(23, 59, 59, 0);
    return format(newDate, fm);
}

export function fDateStartTime(date, newFormat) {
    const fm = newFormat || 'yyyy-MM-dd HH:mm:ss';
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return format(newDate, fm);
}

export function fDateStrIntoDate(dateString) {
    /* function has written to convert custom string like 'Nov-2023' into Date 
     * Date('Nov-2023') returns NaN on Safari browser.
     * To resolve this problem
     */
   // console.log("fDateStrIntoDate->dateString=> ", dateString);

    const options = { day: 'numeric', month: 'short', year: 'numeric' };

    const date = new Date(dateString);

    let parsedDate = date.toLocaleDateString('en-US', options);

    if (parsedDate === "Invalid Date") {
        parsedDate = parse(dateString, 'MMM-yyyy', new Date());
    }

    const formattedDate = newFDate(parsedDate);

    return formattedDate;
}

export function newFDateTime(date, newFormat) {
    const fm = newFormat || 'dd-MMM-yyyy hh:mm a';

    return date ? format(new Date(date), fm) : '';

}
